module.exports = __webpack_public_path__ + "static/media/2.635d2999.svg";